<template>
    <div>
        <div class="z-50 cursor-pointer">
            <div class="relative bg-white hover:bg-gray-100 rounded-lg cursor-pointer">
                <div @click="isOpen = ! isOpen" class="py-2 px-4 flex flex-row items-center stroke-gray-700">
                    <inline-svg name="layers" />
                    <span class="px-2 text-sm text-gray-800 font-semibold">Layers</span>
                </div>

                <div v-if="isOpen" class="p-5 absolute mt-1 bg-white border border-gray-200 rounded-md shadow-lg z-50 min-w-[420px]">
                    <div class="flex items-center justify-between">
                        <h2 class="text-lg font-bold">Additional Layers</h2>
                        <div @click="isOpen = false" class="cursor-pointer">
                            <inline-svg name="close" />
                        </div>
                    </div>

                    <div class="mt-3 grid grid-cols-4 gap-1">
                        <div v-for="layer in visibleSortedLayers" :key="layer._key" class="relative">
                            <div 
                                @click="toggleLayer(layer._key)"
                                class="p-2 flex flex-col items-center gap-y-1 hover:bg-gray-100"
                                :class="{ [`${layer._key}_button`]: true, 'bg-blue-50 text-blue-600 font-semibold': layer.isOn }">
                                    <img :src="layer.icon" class="w-10 h-10">
                                    <span class="text-sm text-center">{{ layer.label }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="layers.highways.showStateSelector" class="mt-4" @click.stop>
                        <div class="flex justify-between items-center">
                            <h3 class="text-md font-semibold">Selected States</h3>
                            <div>
                                <button @click="openStateSelectorModal" class="text-sm text-blue-600 hover:underline">Manage</button>
                                <button @click="clearStateSelection" class="ml-2 text-sm text-blue-600 hover:underline">Clear</button>
                            </div>
                        </div>

                        <div class="mt-1 text-sm text-gray-600 font-medium border p-2 rounded-md min-h-[40px]">
                            <span v-if="selectedStates.length === 0">None selected</span>
                            <span v-else>{{ selectedStateNames }}</span>
                        </div>

                        <button
                            @click="loadHighways"
                            :disabled="selectedStates.length === 0"
                            class="mt-3 w-full bg-blue-600 text-white font-semibold p-2 rounded-md hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
                        >
                            Load Highways
                        </button>
                        <state-selector-modal :selected-states.sync="selectedStates" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import InlineSvg from "../InlineSvg";
    import StateSelectorModal from './StateSelectorModal.vue';

    export default {
        components: {InlineSvg, StateSelectorModal},
        data() {
            return {
                isOpen: false,
                selectedStates: [],
            }
        },

        watch: {
            // 'layers.travel_time.parameters.travel_type'() {
            //     this.$store.dispatch('fetchTravelTime');
            // }
        },

        computed: {
            ...mapState(['reatlas']),

            layers() {
                return this.reatlas.layers;
            },
            visibleSortedLayers() {
                // Convert layers object to array with key
                return Object.entries(this.reatlas.layers)
                    .filter(([key, layer]) => !layer.hide)
                    .sort(([, a], [, b]) => a.sortOrder - b.sortOrder)
                    .map(([key, layer]) => ({ ...layer, _key: key }));
            },

            availableStates() {
                return _.sortBy(this.reatlas.states, 'name') || [];
            },

            selectedStateNames() {
                return this.selectedStates
                    .map(stateCode => {
                        const state = this.availableStates.find(s => s.state === stateCode);
                        return state ? state.name : '';
                    })
                    .filter(Boolean)
                    .join(', ');
            },

            markers() {
                return _.sortBy(_.filter(this.reatlas.markers, marker => {
                    return ['site', 'comp'].includes(marker.type);
                }), marker => {
                    return marker.type == 'site'
                     ? marker.item.building.address_line_1
                     : marker.item.address_line_1
                });
            },
        },

        methods: {
            toggleLayer(layer) {
                this.$store.dispatch('toggleLayer', layer);
                if (layer !== 'highways') {
                    this.isOpen = false;
                }
            },

            loadHighways() {
                const selectedCodes = this.selectedStates;

                if (selectedCodes.length === 0) {
                    //console.log("No states selected.");
                    return;
                }

                //console.log('Dispatching loadHighways action with selected states:', selectedCodes);
                this.$store.dispatch('loadHighways', selectedCodes);
                this.isOpen = false;
            },

            openStateSelectorModal() {
                this.$modal.show('state-selector-modal');
            },

            clearStateSelection() {
                this.selectedStates = [];
            },
        }
    }
</script>
